module.exports = __webpack_public_path__ + "img/settings-gears.34803324.png";